document.addEventListener('DOMContentLoaded', () => {
  // FormatNum: Inject thousands comma
  function numberWithCommas(number) {
    const parts = number.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  const thousands = document.querySelectorAll('.thousands');
  for (let i = 0; i < thousands.length; i++) {
    const num = thousands[i].textContent;
    const commaNum = numberWithCommas(num);
    thousands[i].textContent = commaNum;
  }

});
